var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapacitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#53B9FF",
    d: "M4.204 5.707.033 9.884l6.433 6.452L0 22.822 4.158 27l6.48-6.487 6.443 6.44 4.172-4.176L4.204 5.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#119EFF",
    d: "m14.82 16.337-4.183 4.177 6.444 6.44 4.172-4.176-6.433-6.441Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m14.82 16.337-4.183 4.177 1.61 1.6 2.573-5.777Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#53B9FF",
    d: "M20.521 10.65 27 4.165 22.827 0 16.35 6.474 9.905.033 5.734 4.21l17.048 17.07 4.172-4.177-6.433-6.452Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#119EFF",
    d: "m12.167 10.651 4.183-4.177L9.905.034 5.734 4.21l6.433 6.441Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m12.167 10.65 4.182-4.176-1.61-1.602-2.572 5.778Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacitor);
export default __webpack_public_path__ + "static/media/Capacitor.c5cd6d957ac63a776a91089ee6329645.svg";
export { ForwardRef as ReactComponent };